export default function WindowBrands() {
  const brands = [
    {
      name: 'Tryba',
      type: 'PVC & Aluminium',
      description: 'Leader français de la menuiserie',
      image: 'https://public.readdy.ai/ai/img_res/9e989f54c21d9a220a5b4b7bf7ef9cf1.jpg',
      certifications: ['NFC', 'E', 'Qualibat'],
    },
    {
      name: 'K-Line',
      type: 'Aluminium',
      description: 'Excellence en menuiserie aluminium',
      image: 'https://readdy.ai/api/search-image?query=sleek%20modern%20aluminum%20window%20frame%20with%20slim%20profile%20K-Line%20style%20contemporary%20design%20large%20glass%20surface%20minimalist%20black%20aluminum%20frame%20installed%20in%20modern%20architecture%20simple%20white%20background&width=400&height=300&seq=kline-window-002&orientation=landscape',
      certifications: ['Qualibat', 'Acotherm'],
    },
    {
      name: 'Schüco',
      type: 'PVC & Aluminium',
      description: 'Innovation allemande depuis 1951',
      image: 'https://readdy.ai/api/search-image?query=premium%20German%20engineered%20PVC%20window%20Schuco%20style%20high%20performance%20double%20glazing%20white%20frame%20modern%20design%20superior%20insulation%20quality%20craftsmanship%20simple%20white%20background&width=400&height=300&seq=schuco-window-003&orientation=landscape',
      certifications: ['CE', 'Passivhaus'],
    },
    {
      name: 'Kömmerling',
      type: 'PVC',
      description: 'Technologie PVC haut de gamme',
      image: 'https://readdy.ai/api/search-image?query=high%20quality%20white%20PVC%20window%20Kommerling%20style%20advanced%20technology%20multi%20chamber%20profile%20energy%20efficient%20double%20glazed%20modern%20residential%20window%20simple%20white%20background&width=400&height=300&seq=kommerling-window-004&orientation=landscape',
      certifications: ['NF', 'CSTB'],
    },
    {
      name: 'Veka',
      type: 'PVC',
      description: 'Qualité européenne reconnue',
      image: 'https://readdy.ai/api/search-image?query=European%20quality%20white%20PVC%20window%20Veka%20style%20classic%20design%20reliable%20performance%20double%20glazing%20residential%20window%20frame%20clean%20professional%20look%20simple%20white%20background&width=400&height=300&seq=veka-window-005&orientation=landscape',
      certifications: ['RAL', 'ISO 9001'],
    },
    {
      name: 'Reynaers',
      type: 'Aluminium',
      description: 'Design et performance aluminium',
      image: 'https://readdy.ai/api/search-image?query=sophisticated%20aluminum%20window%20Reynaers%20style%20architectural%20design%20slim%20frame%20large%20glass%20area%20modern%20luxury%20window%20dark%20gray%20aluminum%20contemporary%20building%20simple%20white%20background&width=400&height=300&seq=reynaers-window-006&orientation=landscape',
      certifications: ['CE', 'Qualicoat'],
    },
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-slate-50 via-blue-50 to-white relative overflow-hidden hidden md:block">
      {/* Effets de fond décoratifs */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-200 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-amber-200 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* En-tête moderne */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-blue-600 to-cyan-600 px-6 py-3 rounded-full mb-6 shadow-lg">
            <i className="ri-award-fill text-amber-300 text-xl"></i>
            <span className="text-white font-bold text-sm uppercase tracking-wider">
              Fabricants Partenaires Certifiés
            </span>
          </div>
          
          <h2 className="text-5xl lg:text-6xl font-extrabold text-gray-900 mb-6 leading-tight">
            Marques de Fenêtres<br />
            <span className="bg-gradient-to-r from-blue-600 to-cyan-600 bg-clip-text text-transparent">
              Premium & Certifiées
            </span>
          </h2>
          
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Nous intervenons sur toutes les grandes marques de menuiseries PVC et Aluminium avec expertise et garantie constructeur
          </p>
        </div>

        {/* Grille de marques avec images */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {brands.map((brand, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden border border-gray-100 hover:border-blue-200"
            >
              {/* Image de la fenêtre */}
              <div className="relative h-56 overflow-hidden bg-gradient-to-br from-gray-50 to-gray-100">
                <img
                  src={brand.image}
                  alt={`Fenêtre ${brand.name}`}
                  className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute top-4 left-4 bg-white/95 backdrop-blur-sm px-4 py-2 rounded-full shadow-lg">
                  <span className="text-blue-600 font-bold text-lg">{index + 1}</span>
                </div>
              </div>

              {/* Contenu */}
              <div className="p-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-2 group-hover:text-blue-600 transition-colors">
                  {brand.name}
                </h3>
                
                <div className="inline-block bg-gradient-to-r from-blue-50 to-cyan-50 px-3 py-1 rounded-full mb-3">
                  <span className="text-sm font-semibold text-blue-700">
                    {brand.type}
                  </span>
                </div>
                
                <p className="text-gray-600 mb-4 text-sm leading-relaxed">
                  {brand.description}
                </p>

                {/* Certifications */}
                <div className="flex flex-wrap gap-2">
                  {brand.certifications.map((cert, idx) => (
                    <span
                      key={idx}
                      className="inline-flex items-center bg-gradient-to-r from-green-50 to-emerald-50 text-green-700 px-3 py-1 rounded-full text-xs font-semibold border border-green-200"
                    >
                      <i className="ri-checkbox-circle-fill mr-1 text-green-600"></i>
                      {cert}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Garanties et engagement */}
        <div className="mt-20 bg-gradient-to-r from-blue-600 to-cyan-600 rounded-3xl p-10 text-center shadow-2xl">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center justify-center mb-6">
              <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center">
                <i className="ri-shield-check-line text-4xl text-white"></i>
              </div>
            </div>
            
            <h3 className="text-3xl lg:text-4xl font-bold text-white mb-4">
              Garantie Constructeur Préservée
            </h3>
            
            <p className="text-blue-100 text-lg mb-8 leading-relaxed">
              Toutes nos interventions respectent les préconisations des fabricants et préservent vos garanties constructeur. Pièces d'origine et savoir-faire certifié.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                <i className="ri-tools-line text-3xl text-amber-300 mb-3"></i>
                <div className="text-white font-bold mb-1">Pièces d'Origine</div>
                <div className="text-blue-100 text-sm">Garanties constructeur</div>
              </div>
              
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                <i className="ri-user-star-line text-3xl text-amber-300 mb-3"></i>
                <div className="text-white font-bold mb-1">Techniciens Certifiés</div>
                <div className="text-blue-100 text-sm">Formation continue</div>
              </div>
              
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                <i className="ri-time-line text-3xl text-amber-300 mb-3"></i>
                <div className="text-white font-bold mb-1">Intervention Rapide</div>
                <div className="text-blue-100 text-sm">Sous 48h à Lyon</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
